import { BaseProvider } from "./base.provider";
import { jsonParser } from "../utilities/parsers";
import { injectScript } from "../utilities/dom-mutations";
export class BitvilleProvider extends BaseProvider {
    initBitville(launchData) {
        const { clientScriptData } = launchData;
        const scriptData = jsonParser(clientScriptData);
        if (scriptData.customer) {
            /* @ts-ignore */
            const lch = new LotteryProductComponentHandler();
            const handleBettingLoginRequest = window.verticalBridge.authenticate;
            const handleTrackBetButtonRequest = function (_input) { };
            lch.setParam("server", scriptData.server);
            lch.setParam("account", scriptData.account);
            lch.setParam("customer", scriptData.customer);
            lch.setParam("loginHandler", handleBettingLoginRequest, "function");
            lch.setParam("trackBetButtonHandler", handleTrackBetButtonRequest, "function");
            const playblockModule = {
                name: "betradar",
                element: "#lobby_game",
                module: "home",
                currencySymbol: scriptData.currencySymbol,
                locale: scriptData.language,
                integration: "minimal",
                navStyle: "slider",
                event_bettingLoginRequest: handleBettingLoginRequest,
                event_trackBetButtonRequest: handleTrackBetButtonRequest,
            };
            lch.createComponent(playblockModule);
        }
        else {
            /* @ts-ignore */
            const lch = new LotteryProductComponentHandler();
            const handleBettingLoginRequest = window.verticalBridge.authenticate;
            lch.setParam("server", scriptData.server);
            lch.setParam("account", scriptData.account);
            lch.setParam("loginHandler", handleBettingLoginRequest, "function");
            const playblockModule = {
                name: "betradar",
                element: "#lobby_game",
                module: "home",
                currencySymbol: scriptData.currencySymbol,
                locale: scriptData.language,
                integration: "minimal",
                navStyle: "slider",
                event_bettingLoginRequest: handleBettingLoginRequest,
            };
            lch.createComponent(playblockModule);
        }
    }
    init() {
        const { clientScriptData } = this.launchData;
        const scriptData = jsonParser(clientScriptData);
        const scripts = [
            {
                url: scriptData.componentUrl, // TODO: Fetch this from API
            },
        ];
        const mappedScripts = scripts.map((s, index) => {
            return {
                hid: `bitvilleexternalscript-${index}`,
                src: s.url,
                callback: () => this.initBitville(this.launchData),
            };
        });
        injectScript(mappedScripts);
    }
}
